import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import GetTasks from '../../api/task/get_tasks';
import TaskDetail from '../../components/task detail/task_detail';
import './tasks.css';
import SubjectIcon from '@material-ui/icons/Subject';
import {Button, Chip} from '@material-ui/core';
import Loader from '../../components/loader/loader';
import AlertDialog from '../../components/alert dialog/dialog';
import GetHistoryAPI from '../../api/history/history';
import { AuthorizationContext } from '../../context/authorizationContext';
import { useLocation } from 'react-router-dom'

const Tasks = ()=>{
    const [task_detail, setTaskDetail] = useState(null);
    const [all_task_detail, setAllTaskDetail] = useState([]);
    const [visible, setVisible] = useState(false);
    const [visible_loader, setVisibleLoader] = useState(false);
    const [visible_dialog, setVisibledialog] = useState(false);
    const [title_dialog, setTitleDialog] = useState("");
    const [button_dialog, setButtonDialog] = useState("");

    const { setPath } = useContext(AuthorizationContext);
    const location = useLocation();

    useEffect(async()=>{
        setVisibleLoader(true);
        if(window.location.pathname === "/history"){
            setVisible(false);
            setPath(window.location.pathname)
            GetHistoryAPI({}, (res)=>{
                setVisibleLoader(false);
                if(res.data.status === true){
                    setAllTaskDetail(res.data.data);
                    if(res.data.data.length === 0){
                        setTitleDialog("No history available.");
                        setButtonDialog("Ok");
                        setVisibledialog(true);
                    }
                }
                else{
                    console.log(false);
                    setVisibleLoader(false);
                    setTitleDialog(res.data.data);
                    setButtonDialog("Close");
                    setVisibledialog(true);
                }
            }, (err)=>{
                setVisibleLoader(false);
                console.log(err);
            })
        }
        else if(location.pathname === "/tasks"){
            setVisible(false);
            setPath(window.location.pathname)
            GetTasks({}, (response)=>{
                // console.log("Getting response of get tasks from tasks.jsx", response);
                if(response.data.status){
                    // console.log("status is true");
                    setVisibleLoader(false);
                    setAllTaskDetail(response.data.data);
                    if(response.data.data.length === 0){
                        setTitleDialog("No work assigned to you now.");
                        setButtonDialog("Ok");
                        setVisibledialog(true);
                    }
                }
                else{
                    console.log(false);
                    setVisibleLoader(false);
                    setTitleDialog(response.data.data);
                    setButtonDialog("Close");
                    setVisibledialog(true);
                }
            }, (error)=>{
                console.log(error);
            })
        }
    }, [location.pathname]);

    return (
        <>
            {visible_loader === true && <Loader />}
            <AlertDialog visible={visible_dialog} title={title_dialog} button={button_dialog} close={()=>{
                setVisibledialog(false);
                window.location.replace("https://onboard-10.web.app/");
            }}  />
            <div className="tasks_section ">
                <div className="left_task">
                    {
                        all_task_detail.map((value, index)=>{
                            return (
                                <>
                                    <div className="card" onClick={()=>{
                                        setTaskDetail({
                                            task_id: value.task_id,
                                            title: value.title,
                                            description: value.description,
                                            assigned: value.assigned,
                                            status: value.status,
                                            attachment: value.attachment,
                                            checkList: value.checkList,
                                            dueDate: value.dueDate
                                        })
                                        setVisible(true);
                                    }}>
                                        <h1>{value.title}</h1>
                                        <div style={{display: "flex", alignItems: 'center', flexWrap: 'wrap'}}>
                                        {value.description !== "" ? <SubjectIcon /> : null}
                                        {
                                            value?.status === "Not Started" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#16a085", color: "#fff"}}></Button>
                                        }
                                        {
                                            value?.status === "Development" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#e67e22", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Error" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#e74c3c", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "QC" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#2980b9", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Reference" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#34495e", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Review" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#27ae60", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Completed" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#27ae60", color: '#fff'}}></Button>
                                        }
                                        </div>
                                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                        {
                                            value?.assigned.map((v)=>{
                                                return <Chip label={v} variant="default" style={{margin: "5px"}} />
                                            })
                                        }
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
                <div className="right_task">
                    <TaskDetail visible={visible} key={task_detail?.task_id} task={task_detail} />
                </div>
            </div>
        </>
    )
};

export default Tasks;